import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"text-align":"center","margin":"0px auto","max-width":"700px"}
}, " Get a fast & free Renters Insurance quote ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { style: {"max-width":"600px","margin":"0px auto"} }
const _hoisted_9 = { class: "fieldleft" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_11 = { class: "fieldright" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "confirmaddress",
  style: {"max-width":"600px","margin":"0px auto"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Let's make sure your address is correct.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("em", null, "Make any changes below.", -1)
const _hoisted_20 = { class: "fieldleft" }
const _hoisted_21 = { class: "fieldright" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, "Apt / Suite ", -1)
const _hoisted_23 = { class: "fieldcol3address" }
const _hoisted_24 = { class: "fieldcol3address middlecol" }
const _hoisted_25 = { class: "fieldcol3address lastcol" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { style: {"text-align":"center"} }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import VueGoogleAutocomplete from "./../../../node_modules/vue-google-autocomplete/src/VueGoogleAutocomplete.vue";
import Loader from "@/components/MainLoader.vue";
import UsStatesBox from "@/components/UsStatesBox.vue";
import { InsuranceAddress } from "@/models/InsuranceAddress";
import { User } from "@/models/User";
import ValidationError from "@/components/ValidationError.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import { onMounted, ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import { useStatusStore } from "@/stores/root/status";
import { stat, scrollTop } from "@/utils/Utils";
import { Namespaces } from "@vue/compiler-core";

// const props = defineProps({
//   anchor: {
//     type: String,
//     default: "",
//   },
//   nextStep: {
//     type: String,
//     default: "",
//   },
// });

const title = "Introduction";

export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteIntroduction',
  setup(__props) {

const loading: Ref<boolean> = ref(false);
const quote = useQuoteStore();
const userStore = useUserStore();
const user: User = userStore.user;
const validationErrors: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const stateBox = ref("");
const googleAutoComplete = ref("");

//Function not used
// function sleep(ms: number) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, ms);
//   });
// }

const validated: ComputedRef<any> = computed(() => {
  return (
    quote.address.firstName &&
    quote.address.lastName &&
    quote.address.address &&
    quote.address.city &&
    quote.address.state.short &&
    quote.address.zip
  );
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (!quote.address.firstName) {
    const error = {
      name: "firstName",
      value: "First name is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.address.lastName) {
    const error = {
      name: "lastName",
      value: "Last name is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.address.address) {
    const error = {
      name: "address",
      value: "Address is required.",
    };
    validationErrors.value.push(error);
    const error2 = {
      name: "addressSearch",
      value: "Address is required.",
    };
    validationErrors.value.push(error2);
  }
  if (!quote.address.city) {
    const error = {
      name: "city",
      value: "City is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.address.state.short) {
    const error = {
      name: "state",
      value: "State is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.address.zip) {
    const error = {
      name: "zip",
      value: "Zip code is required.",
    };
    validationErrors.value.push(error);
  }
}

onMounted(async () => {
  if (user && user.loggedIn && user.firstName && !quote.address.firstName) {
    quote.address.firstName = user.firstName;
  }
  if (user && user.loggedIn && user.lastName && !quote.address.lastName) {
    quote.address.lastName = user.lastName;
  }
});

function getStateFromAddressComponent(place: any) {
  for (let i = 0; i < place.address_components.length; i++) {
    const addressType = place.address_components[i].types[0];

    if (addressType == "administrative_area_level_1") {
      const val = place.address_components[i];
      return {
        short: val["short_name"],
        title: val["long_name"],
      };
    }
  }
  return {
    short: "",
    title: "",
  };
}

/**
 * When the location found
 * @param {Object} addressData Data of the found location
 * @param {Object} placeResultData PlaceResult object
 * @param {String} id Input container ID
 */
function getAddressData(addressData: any, placeResultData: any, id: string) {
  stat(statusStore).clear();
  quote.address.formatted = placeResultData.formatted_address;
  quote.address.zip = addressData.postal_code;

  const state = getStateFromAddressComponent(placeResultData);
  quote.address.state.short = state.short;
  quote.address.state.title = state.title;
  if (stateBox.value) {
    (stateBox.value as any).$forceUpdate();
  }
  quote.address.address =
    (addressData.street_number ? addressData.street_number + " " : "") +
    addressData.route;
  quote.address.city = addressData.locality;
  if (validationErrors.value.length) {
    createValidationMessages();
    if (!validated.value) {
      stat(statusStore).error("Please fill in required fields.");
    }
  }
}

function updateGoogleAutocomplete() {
  const googleAutoCompletes = googleAutoComplete.value as any;
  if (googleAutoCompletes) {
    googleAutoCompletes.update(quote.address.formatted);
  }
}

function noAddressResultsFound() {
  quote.address = new InsuranceAddress();
  updateGoogleAutocomplete();
  stat(statusStore).error("No address has been found. Please try again.");
}

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  clearValidationMessage(event.target.name);
}

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}
function goToPage() {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollTop();
    return;
  }
  quote.setQuoteStep("quote-questions");
}

return (_ctx: any,_cache: any) => {
  const _component_red = _resolveComponent("red")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(StatusComponent),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('firstName') }]),
              for: "firstname"
            }, [
              _createTextVNode("First Name "),
              _hoisted_10
            ], 2),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(quote).address.firstName) = $event)),
              type: "text",
              name: "firstName",
              class: _normalizeClass({ validationfield: hasErrors('firstName') }),
              onInput: validatedFieldChanged
            }, null, 34), [
              [_vModelText, _unref(quote).address.firstName]
            ]),
            _createVNode(ValidationError, {
              name: "firstName",
              errors: validationErrors.value
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", {
              class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('lastName') }])
            }, [
              _createTextVNode(" Last Name "),
              _hoisted_12
            ], 2),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(quote).address.lastName) = $event)),
              type: "text",
              name: "lastName",
              class: _normalizeClass({ validationfield: hasErrors('lastName') }),
              onInput: validatedFieldChanged
            }, null, 34), [
              [_vModelText, _unref(quote).address.lastName]
            ]),
            _createVNode(ValidationError, {
              name: "lastName",
              errors: validationErrors.value
            }, null, 8, ["errors"])
          ]),
          _hoisted_13,
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('addressSearch') }])
          }, [
            _createTextVNode("Enter the address you'd like to insure "),
            (_unref(quote).address.address === '')
              ? (_openBlock(), _createBlock(_component_red, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("*")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("form", {
            autocomplete: "off",
            onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["enter"]))
          }, [
            _createVNode(VueGoogleAutocomplete, {
              id: "maps",
              ref_key: "googleAutoComplete",
              ref: googleAutoComplete,
              name: "addressSearch",
              placeholder: "",
              country: "us",
              class: _normalizeClass({ validationfield: hasErrors('addressSearch') }),
              onPlacechanged: getAddressData,
              onNoResultsFound: _cache[2] || (_cache[2] = ($event: any) => (noAddressResultsFound())),
              onError: _cache[3] || (_cache[3] = ($event: any) => (noAddressResultsFound()))
            }, null, 8, ["class"])
          ], 32),
          _createVNode(ValidationError, {
            name: "addressSearch",
            errors: validationErrors.value
          }, null, 8, ["errors"]),
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          (_unref(quote).address.address !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('address') }])
                  }, [
                    _createTextVNode("Street Address "),
                    _createVNode(_component_red, null, {
                      default: _withCtx(() => [
                        _createTextVNode("*")
                      ]),
                      _: 1
                    })
                  ], 2),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(quote).address.address) = $event)),
                    type: "text",
                    name: "address",
                    class: _normalizeClass({ validationfield: hasErrors('address') }),
                    onInput: validatedFieldChanged
                  }, null, 34), [
                    [
                      _vModelText,
                      _unref(quote).address.address,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(ValidationError, {
                    name: "address",
                    errors: validationErrors.value
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(quote).address.apt) = $event)),
                    type: "text"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(quote).address.apt,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('city') }])
                  }, [
                    _createTextVNode("City "),
                    _createVNode(_component_red, null, {
                      default: _withCtx(() => [
                        _createTextVNode("*")
                      ]),
                      _: 1
                    })
                  ], 2),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(quote).address.city) = $event)),
                    type: "text",
                    name: "city",
                    class: _normalizeClass({ validationfield: hasErrors('city') }),
                    onInput: validatedFieldChanged
                  }, null, 34), [
                    [
                      _vModelText,
                      _unref(quote).address.city,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(ValidationError, {
                    name: "city",
                    errors: validationErrors.value
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('state') }])
                  }, [
                    _createTextVNode("State "),
                    _createVNode(_component_red, null, {
                      default: _withCtx(() => [
                        _createTextVNode("*")
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createVNode(UsStatesBox, {
                    ref_key: "stateBox",
                    ref: stateBox,
                    modelValue: _unref(quote).address.state,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(quote).address.state) = $event)),
                    initial: _unref(quote).address.state,
                    name: "state",
                    "select-style": { validationfield: hasErrors('state') },
                    onChange: validatedFieldChanged
                  }, null, 8, ["modelValue", "initial", "select-style"]),
                  _createVNode(ValidationError, {
                    name: "state",
                    errors: validationErrors.value
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('zip') }])
                  }, [
                    _createTextVNode(" Zip "),
                    _createVNode(_component_red, null, {
                      default: _withCtx(() => [
                        _createTextVNode("*")
                      ]),
                      _: 1
                    })
                  ], 2),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(quote).address.zip) = $event)),
                    type: "text",
                    name: "zip",
                    class: _normalizeClass({ validationfield: hasErrors('zip') }),
                    onInput: validatedFieldChanged
                  }, null, 34), [
                    [
                      _vModelText,
                      _unref(quote).address.zip,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(ValidationError, {
                    name: "zip",
                    errors: validationErrors.value
                  }, null, 8, ["errors"])
                ]),
                _hoisted_26,
                _hoisted_27
              ]))
            : _createCommentVNode("", true),
          _hoisted_28,
          _hoisted_29,
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              class: _normalizeClass({ disabled: !validated.value }),
              onClick: goToPage
            }, " Start a quote ", 2)
          ]),
          _hoisted_32,
          _hoisted_33
        ])
      ])
    ])
  ]))
}
}

})